import React from 'react'
import PlaylistPreview from '../../playlist/components/PlayListTable/PlaylistPreview'
import MessageRender from '../../components/Message/MessageRender'

interface InputProps {
  playlist: any
  selectedIcon: any
}

const PlayListRow: React.FC<InputProps> = ({ playlist, selectedIcon }) => {

  return (
    <tr key={playlist.Id}>
      <td>{playlist.Id}</td>
      <td>{playlist.Title}</td>
      <td>{playlist.Description}</td>
      <td>
        {(playlist.FrontPreviewUrl || playlist.RearPreviewUrl) && selectedIcon != 'Image' ? (
          <div className='d-flex gap-5'>
            {playlist.FrontPreviewUrl && playlist.ShowAll && (
              <PlaylistPreview
                selectedIcon={selectedIcon}
                previewUrl={playlist.FrontPreviewUrl}
                pngPreviewUrl={playlist.ShowAll[0]?.PreviewUrl}
              />
            )}
            {playlist.FrontPreviewUrl && playlist.ShowFront && (
              <PlaylistPreview
                selectedIcon={selectedIcon}
                previewUrl={playlist.FrontPreviewUrl}
                pngPreviewUrl={playlist.ShowFront[0]?.PreviewUrl}
              />
            )}
            {playlist.RearPreviewUrl && playlist.ShowRear && (
              <PlaylistPreview
                selectedIcon={selectedIcon}
                previewUrl={playlist.RearPreviewUrl}
                pngPreviewUrl={playlist.ShowRear[0]?.PreviewUrl}
              />
            )}
          </div>
        ) : (
          <div className='d-flex flex-row gap-5 flex-wrap'>
            {playlist.ShowAll &&
              playlist.ShowAll.map((msg: any, i: number) => {
                return (
                  <React.Fragment key={`img-${playlist.Id}-${i}`}>
                    <MessageRender message={msg}></MessageRender>
                  </React.Fragment>
                )
              })}
            {playlist.ShowFront &&
              playlist.ShowFront.map((msg: any, i: number) => {
                return (
                  <React.Fragment key={`img-${playlist.Id}-${i}`}>
                    <MessageRender message={msg}></MessageRender>
                  </React.Fragment>
                )
              })}
            {playlist.ShowRear &&
              playlist.ShowRear.map((msg: any, i: number) => {
                return (
                  <React.Fragment key={`img-${playlist.Id}-${i}`}>
                    <MessageRender message={msg}></MessageRender>
                  </React.Fragment>
                )
              })}
          </div>
        )}
      </td>
    </tr>
  )
}

export default PlayListRow
